import type { JSX } from "react";

import { FyndLoader } from "../ui/FyndLoader.js";

/**
 * Full-route Suspense fallback. Shown when a lazy-loaded route's chunk is
 * still being fetched/parsed. Sized larger than the inline `LoadingState`
 * since it owns the whole page region.
 */
export function RouteFallback(): JSX.Element {
  return (
    <div className="flex min-h-[50vh] items-center justify-center p-12">
      <FyndLoader size="lg" />
    </div>
  );
}
